import {
  IWorkloadCounts,
  PATIENT_STATUS,
  SERVICE_STATUS,
  workloadServiceStatus,
} from "@home-health-notify/domain";
import { getGroupStatusProperty, serviceStatusLabel } from "hhn-commons";
import React from "react";
import PatientHomeIcon from "../../../../../common/PatientHomeIcon";
import {
  ServiceStatus,
  ServiceStatusCount,
  ServiceStatusItemWrapper,
  ServiceStatusWrapper,
  SOCTotalCount,
  VerticalDivider,
} from "../AdvanceSearchList.style";

type ServiceStatusCountsProps = {
  userId: string;
  workloadCounts: IWorkloadCounts;
};

const ServiceStatusCounts = ({
  userId,
  workloadCounts,
}: ServiceStatusCountsProps) => {
  const serviceStatus: SERVICE_STATUS[] = [
    SERVICE_STATUS.PENDING,
    SERVICE_STATUS.ACTIVE,
    SERVICE_STATUS.DISCHARGED,
  ];
  const activePatientStatusTitle = getGroupStatusProperty(
    +PATIENT_STATUS.ACTIVE,
  ).title;

  return (
    <ServiceStatusWrapper>
      <div style={{ marginRight: 7 }} data-testid={`${activePatientStatusTitle.toLowerCase()}-status-img`}>
        <PatientHomeIcon
          size={30}
          status={+PATIENT_STATUS.ACTIVE}
        />
      </div>
      <SOCTotalCount data-testid="soc-total-count">
        {workloadCounts.socTotal}
      </SOCTotalCount>
      <VerticalDivider orientation="vertical" />
      {serviceStatus.map((status: SERVICE_STATUS) => {
        return (
          <ServiceStatusItemWrapper
            key={`${userId}-${status}`}
            data-testid="service-status"
          >
            <ServiceStatus status={status}>
              {serviceStatusLabel[status]}
            </ServiceStatus>
            <ServiceStatusCount>
              {
                workloadCounts[
                  workloadServiceStatus[status] as keyof IWorkloadCounts
                ]
              }
            </ServiceStatusCount>
          </ServiceStatusItemWrapper>
        );
      })}
    </ServiceStatusWrapper>
  );
};

export default ServiceStatusCounts;
